




































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import node from "./node.vue";
@Component({
  components: {
    node
  }
})
export default class searchForm extends Vue {
  formData: any = {};
  @Prop({ required: true })
  formOptionList: any;
  @Prop()
  onResetBtnClick: any;
  @Prop()
  onSearchBtnClick: any;
  @Prop({ default: false, type: Boolean })
  loading: boolean | undefined;
  isInit: boolean = false;
  isMore: boolean = false;
  @Watch("formOptionList")
  onFormOptionListChange() {
    this.init();
  }
  onFormDataChange(val: any) {
    this.$emit("change", this.formData);
  }
  mounted() {
    this.init();
    this.$emit("change", this.formData);
    this.isInit = true;
  }
  init() {
    for (let i of this.formOptionList) {
      this.$set(this.formData, i.key, i.value);
    }
  }
  handleResetBtnClick() {
    this.init();
    this.$emit("change", this.formData);
    this.onResetBtnClick();
  }
  handleSearchBtnClick() {
    this.onSearchBtnClick();
  }
  updateData(key: string, value: any) {
    this.$set(this.formData, key, value);
    this.$emit("change", this.formData);
  }
}
